<template>
	<div>
		<TopAppBar
			:leftBtnMode="leftBtnMode"
			:rightBtnMode="rightBtnMode"
			:title="title"
			:leftBtnMethod="leftBtnMethod"
			:rightBtnMethod="rightBtnMethod"
      :hideCategory="true"
			staticMode="true"
		>
		</TopAppBar>
		<div class="d-flex flex-column">
			<TopAppBarDrawer></TopAppBarDrawer>
			<main class="main-wrapper flex-grow-1">
					<div class="d-flex align-items-center bg-white">
						<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
							{{ $t('1298') }}
						</div>
					</div>
					<div class="divider"></div>
					<div class="container container--narrow pdt-50">
							<div class=" pdl-24 pdr-24 position-relative">
								<label class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
										data-mdc-auto-init="MDCTextField" >
										<span class="mdc-notched-outline">
											<span class="mdc-notched-outline__leading"></span>
											<span class="mdc-notched-outline__notch">
													<!-- <span class="mdc-floating-label" id="my-label-id">{{$t('1299')}}</span> -->
											</span>
											<span class="mdc-notched-outline__trailing"></span>
										</span>
										<input class="mdc-text-field__input t-body6 font-r"
											type="text"
											aria-labelledby="my-label-id"
											:placeholder="$t('1299')"
											v-model="search"
											autocomplete="off"
											maxlength="2">
										<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing d-block"
														tabindex="0" role="button">search</i>
								</label>
								<div class="mdc-card mgt-8 store-list language-list">
										<ul class="mdc-list">
											<li class="mdc-list-item pdl-24 pdr-24 pdt-16 pdb-16"
											v-for="(language, index) in searchLang()"
            :class="[(selectedlang === language.code) ? 'selected' : null]"
            :key="index"
            @click="selectLang(language.code)" @keypress="selectLang(language.code)" tabindex="0"
												 >
											<span class="mdc-list-item__ripple"></span>
											<span class="mdc-list-item__text t-body6 t-color-bodyGrayA font-r">{{language.text}}</span>
											<i class=" material-icons mgl-auto t-color-iconInactive t-weight800" v-if="selectedlang === language.code">
													check
												</i>
											</li>
										</ul>
								</div>
								<div class="mgt-50 mgb-50">
												<!-- <button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8" @click="changeLanguage">
													<div class="mdc-button__ripple"></div>
													<span class="mdc-button__label t-body2 font-r">{{ $t('1926') }}</span>
												</button> -->
												<button class="mdc-button bg-white t-color-secondaryBtnText b-radius4" @click="$router.go(-1)" @keypress="$router.go(-1)" tabindex="0">
													<div class="mdc-button__ripple"></div>
													<span class="mdc-button__label t-body2 font-r">{{$t('5')}}</span>
												</button>
								</div>
							</div>
					</div>
			</main>
		</div>
	</div>
</template>

<style scoped>

</style>

<script>
import TopAppBar from '@/components/TopAppBar.vue'
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import i18nApi from "@/api/i18nApi.js";
import { setUserLanguage } from "@/translations/i18nSetup";
import { mapState, mapMutations } from "vuex";
import memberApi from '@/api/memberApi.js'

export default {

	data() {
		return {
				title:localStorage.getItem('brandName'),
				languageList: [],
				search: "",
				selectedlang: localStorage.getItem("languageInfo")
						? JSON.parse(localStorage.getItem("languageInfo")).code
						: null,
		}
	},
	components: {
		TopAppBar,
		TopAppBarDrawer,
	},

	mixins: [topAppBarMixin],
	  computed: {
    ...mapState(["languageMode"]),
  },
  methods: {
    ...mapMutations(["SET_LANGUAGE_MODE"]),
    searchLang() {
      return this.languageList.filter((lang) => {
        return lang.code.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
      });
    },
    selectLang(code) {
      this.selectedlang = code;
	  this.$confirm({
        title: this.$t("1300"),
        content: this.$t("1301"),
        accept: this.$t("1303"),
        cancel: this.$t("1302"),
      }).then(() => {
        setUserLanguage(this.selectedlang).then(() => {
		  	let option = {
              pushToken : '',
              pushLanguage : this.selectedlang,
              notificationed: false
            }
            memberApi.languageChangePushNotification({option}).then((response)=>{
                this.personalInfo = response.data.data
                this.profileImage = this.personalInfo? this.personalInfo.profile:''
                this.phoneNo = this.personalInfo? this.personalInfo.phone:''
            })
			// memberApi.getMemberInfo().then((response)=>{
            //     let getOption = response.data.data?response.data.data.option:response.data.data
            //     memberApi.languageChangePushNotification({option:getOption}).then((response)=>{
            //   })
            // })
		   const html = document.documentElement // returns the html tag
        	html.setAttribute('dir', this.languageMode)
        });
      });
    },
    changeLanguage() {
      if (!this.selectedlang) return;

      this.$confirm({
        title: this.$t("1300"),
        content: this.$t("1301"),
        accept: this.$t("1303"),
        cancel: this.$t("1302"),
      }).then(() => {
        setUserLanguage(this.selectedlang).then(() => {
		  let option = {
              pushToken : '',
              pushLanguage : this.selectedlang,
              notificationed: false
            }
        //     memberApi.languageChangePushNotification({option}).then((response)=>{
        //         this.personalInfo = response.data.data
        //         this.profileImage = this.personalInfo? this.personalInfo.profile:''
        //         this.phoneNo = this.personalInfo? this.personalInfo.phone:''
        //     })
			memberApi.getMemberInfo().then((response)=>{
                let getOption = response.data.data?response.data.data.option:response.data.data
                 memberApi.languageChangePushNotification({option}).then((response)=>{
              })
            })
		   const html = document.documentElement // returns the html tag
        	html.setAttribute('dir', this.languageMode)
        });
      });
    },
  },
  mounted() {
    let params = {
      brandCode: localStorage.getItem("brandCode"),
    };
    if (localStorage.getItem("brandCode")) {
      // 브랜드 언어 목록 가져오기(get service language list)
      i18nApi.guestLanguagePack(params).then((response) => {
        this.languageList = response.data.data;
      });
    }
  },
}
</script>
<style scoped>
.selected .mdc-list-item__text{
	color:var(--HeadlineBlack) !important
}
</style>
